/* Sivena advertorial (nightsera1) interactivity: FAQ accordion.
   The section markup keeps the original inline onclick="toggleFaq(this)" on each
   .nw-faq-q, so we only need to expose the global. It survives theme-editor
   section re-renders (the attribute is part of the markup), so no re-bind needed. */
(function () {
  function toggleFaq(el) {
    if (!el) return;
    var a = el.nextElementSibling;
    var isOpen = el.classList.contains('open');
    document.querySelectorAll('.nw-faq-q.open').forEach(function (q) {
      q.classList.remove('open');
      if (q.nextElementSibling) q.nextElementSibling.style.maxHeight = null;
    });
    if (!isOpen && a) {
      el.classList.add('open');
      a.style.maxHeight = a.scrollHeight + 'px';
    }
  }
  window.toggleFaq = toggleFaq;
})();
